import { IEnderecos } from '../../../types/tables/IEnderecos';
import { BaseMultiTenantService } from '../base/BaseMultiTenantService';

/**
 * Serviço para gerenciamento de endereços com isolamento multi-tenant
 * Endereços das pessoas cadastradas no sistema
 */
export class EnderecosService extends BaseMultiTenantService<IEnderecos> {
     constructor() {
          super(
               'enderecos', 
               ['logradouro', 'bairro', 'cidade'],
               'fk_id_organizacao'
          );
     }

     /**
      * Busca endereços por pessoa
      */
     async getByPessoa(organizationId: number, pessoaId: number) {
          return await this.client
               .from('enderecos')
               .select(`
                    *,
                    pessoas!fk_id_pessoa (nome, email)
               `)
               .eq(this.organizationIdField, organizationId)
               .eq('fk_id_pessoa', pessoaId)
               .is('deleted_at', null)
               .order('principal', { ascending: false });
     }

     /**
      * Busca endereço principal da pessoa
      */
     async getPrincipalByPessoa(organizationId: number, pessoaId: number) {
          return await this.client
               .from('enderecos')
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('fk_id_pessoa', pessoaId)
               .eq('principal', true)
               .is('deleted_at', null)
               .single();
     }

     /**
      * Busca endereços por CEP
      */
     async getByCep(organizationId: number, cep: string) {
          return await this.client
               .from('enderecos')
               .select(`
                    *,
                    pessoas!fk_id_pessoa (nome, email)
               `)
               .eq(this.organizationIdField, organizationId)
               .eq('cep', cep.replace(/\D/g, ''))
               .is('deleted_at', null);
     }

     /**
      * Busca endereços por cidade
      */
     async getByCidade(organizationId: number, cidade: string) {
          return await this.client
               .from('enderecos')
               .select(`
                    *,
                    pessoas!fk_id_pessoa (nome, email)
               `)
               .eq(this.organizationIdField, organizationId)
               .ilike('cidade', `%${cidade}%`)
               .is('deleted_at', null)
               .order('cidade');
     }

     /**
      * Busca endereços por tipo
      */
     async getByTipo(organizationId: number, tipo: string) {
          return await this.client
               .from('enderecos')
               .select(`
                    *,
                    pessoas!fk_id_pessoa (nome, email)
               `)
               .eq(this.organizationIdField, organizationId)
               .eq('tipo', tipo)
               .is('deleted_at', null);
     }

     /**
      * Define um endereço como principal (e remove dos outros)
      */
     async setPrincipal(organizationId: number, enderecoId: number, pessoaId: number, userId: number) {
          // Remove principal de outros endereços da pessoa
          await this.client
               .from('enderecos')
               .update({
                    principal: false,
                    updated_at: new Date().toISOString(),
                    updated_by: userId
               })
               .eq(this.organizationIdField, organizationId)
               .eq('fk_id_pessoa', pessoaId);

          // Define o endereço como principal
          return await this.client
               .from('enderecos')
               .update({
                    principal: true,
                    updated_at: new Date().toISOString(),
                    updated_by: userId
               })
               .eq(this.organizationIdField, organizationId)
               .eq('id', enderecoId)
               .select();
     }
}
